//Runs on product page only. Calls checkVariantStock on page load, and when the size
//selector inputs are changed.
if ($('body.template-product').length) {
  
//   checkVariantStock($('.pdp__quantity__status').attr('data-variant-quantity'));
  
//   addCheckedtoFirstSize($('.pdp__quantity__status').attr('data-variant-id'));

  $('.size > input').on('change', function(){
    checkVariantStock($(this).attr('data-quantity'));
  });
  
  detectiOSTap();
  
}

//Get the stock message div, and its data attributes. if the quantity is greater to equal to 4,
//add the green class, otherwise remove it. Then perform checks based on what the quantity is, and 
//depending on the amount use the data attributes to change the text.
function checkVariantStock(quantity) {
  var stockMessage = $('.pdp__quantity__status');
  
  var stock4Text = $('.pdp__quantity__status').attr('data-stock-4-text');
  var stock3Text = $('.pdp__quantity__status').attr('data-stock-3-text');
  var stock2Text = $('.pdp__quantity__status').attr('data-stock-2-text');
  var stock1Text = $('.pdp__quantity__status').attr('data-stock-1-text');
  var stock0Text = $('.pdp__quantity__status').attr('data-stock-0-text');
  
  if (quantity >= 4) {
    stockMessage.addClass('green');
  } else {
    stockMessage.removeClass('green');
  }
  
  if (quantity >= 4) {
    stockMessage.text(stock4Text);
  } else if (quantity == 3) {
    stockMessage.text(stock3Text);
  } else if (quantity == 2) {
    stockMessage.text(stock2Text);
  } else if (quantity == 1) {
    stockMessage.text(stock1Text);
  } else {
    stockMessage.text(stock0Text);
  }
}

//Detect iOS taps on the PDP size selectors, preventing the need for double taps.
function detectiOSTap() {
  
  var swatchElement = $('.size label');
  
  swatchElement.each(function(){
    $(this).off('touchstart click').on('touchstart click', function(e) {
//       console.log('click');
    });
  });
}


// function addCheckedtoFirstSize(variantID) {
  
  
  
//   var swatchElement = $('.size');
  
//   swatchElement.each(function(){
//     var swatchVariantID = $(this).attr('data-id');
    
//     if (variantID == swatchVariantID) {
      
//       console.log('called');
     
//       $(this).find('label').click();
//     }
    
//   });

  
// }